
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sst-forum",
      function () {
        return require("private-next-pages/sst-forum/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sst-forum"])
      });
    }
  